import { Injectable } from '@angular/core';
import { BaseApiService } from "../../common/services/base-api-service";
import { User } from "../../common/interfaces/User";
import { Customer } from "../../common/interfaces/Customer";
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  userLoggedIn: boolean = false
  customerLoggedIn: boolean = false

   authChange = new Subject<"">();


  private loggedIn = false;

  constructor(protected readonly apiClient: BaseApiService,) {

  }

  onAuthChanged(){
    this.authChange.next(""); // Emit change
  }

  geCustomer(): Customer | null {
    return this.apiClient.getJwt()?.customer ?? null
  }

  getUser(): User | null {
    return this.apiClient.getJwt()?.user ?? null
  }


  isUserMerchant(): boolean {
    const jwt = this.apiClient.getJwt();
    return !!(jwt && jwt.user && jwt.user.merchantId);
    // return jwt && jwt.user && jwt.user.merchantId ? true : false;
  }

}
